import Image from "image-js";

export default function useImageConverters() {
    const cropToSquare = async (file: File, imageSize: number): Promise<File> => {
        const buffer = await fileToBuffer(file);
        const image = await Image.load(buffer);
        const cropSize = Math.min(image.width, image.height);

        if (cropSize < imageSize) {
            return file;
        }

        const cropImage = image.crop({
            x: image.width / 2 - cropSize / 2,
            y: image.height / 2 - cropSize / 2,
            width: cropSize,
            height: cropSize,
        });

        const convertedBlob = await cropImage
            .resize({
                width: imageSize,
            })
            .toBlob(file.type);

        return new File([convertedBlob], file.name, {
            type: file.type,
            lastModified: Date.now(),
        });
    };

    const fileToBuffer = (file: File): Promise<ArrayBuffer> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => {
                resolve(reader.result as ArrayBuffer);
            };
            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    return {
        cropToSquare,
        fileToBuffer,
    };
}
